import { LESSON_STATUS, LESSON_STYLE } from '@yandex-int/k-common/typings';
import b from 'b_';
import { LessonMeta, Text } from 'platform-components';
import { POPUP_AXIS, POPUP_DIRECTIONS } from 'platform-components/constants';
// @ts-ignore
import * as userSelectors from 'platform-components/src/components/user/selectors';
import { StoreWithUserState } from 'platform-components/src/components/user/selectors';
import React from 'react';
import { connect } from 'react-redux';

import { BLOCK_CARDS_COUNT } from 'common.components/constants';
import * as lessonSelectors from 'common.components/lesson/selectors';
import { LessonStore } from 'common.components/lesson/typings';

import * as selectors from './selectors';

import './lesson-view__meta.scss';

interface StoreProps {
    problemsCount: number;
    duration: number | null;
    isEvaluable: boolean;
    isContentManager: boolean;
    lessonId: number | null;
    readonlyComment: string | null;
    lessonStyle: LESSON_STYLE;
    shouldShowBanner: boolean;
    lessonStatus: LESSON_STATUS;
    isDurationEditable: boolean;
}

interface Props extends StoreProps {}

const LessonViewMeta = (props: Props) => {
    const {
        problemsCount,
        duration,
        isEvaluable,
        isContentManager,
        lessonId,
        readonlyComment,
        lessonStyle,
        shouldShowBanner,
        lessonStatus,
        isDurationEditable,
    } = props;

    const shouldShowWarning = lessonStatus === LESSON_STATUS.NOT_ASSIGNED;

    return (
        <div
            className={b('lesson-view', 'meta', {
                light: lessonStyle === LESSON_STYLE.DARK,
                'with-banner': shouldShowBanner,
            })}
        >
            <LessonMeta.CardsCount
                cardsCount={problemsCount}
                mix="lesson-view__meta-cards-count lesson-view__meta-item"
                shouldShowWarning={shouldShowWarning}
                showIcon
                tooltipProps={{
                    direction: POPUP_DIRECTIONS.TOP,
                    axis: POPUP_AXIS.CENTER,
                    shown: problemsCount >= BLOCK_CARDS_COUNT,
                }}
            />
            {isEvaluable && (isDurationEditable || duration) && (
                <LessonMeta.Duration
                    duration={duration}
                    mix="lesson-view__meta-duration lesson-view__meta-item"
                    shouldShowEmptyDuration
                    showIcon
                />
            )}
            {isContentManager && (
                <div className="lesson-view__meta-id lesson-view__meta-item">
                    <Text id="lessonModal.cmId" values={{ cmId: lessonId }} />
                </div>
            )}
            {readonlyComment && (
                <div className="lesson-view__meta-readonly-comment">
                    <Text type={Text.TYPE.MARKDOWN}>{readonlyComment}</Text>
                </div>
            )}
        </div>
    );
};

const mapStateToProps = <T extends LessonStore & StoreWithUserState>(storeState: T): StoreProps => ({
    problemsCount: lessonSelectors.getLoadedLessonProblems(storeState).length,
    duration: selectors.getDuration(storeState),
    isEvaluable: selectors.getIsEvaluable(storeState),
    isContentManager: userSelectors.getIsContentManager(storeState),
    lessonId: lessonSelectors.getLessonId(storeState),
    readonlyComment: selectors.getReadonlyComment(storeState),
    lessonStyle: lessonSelectors.getLessonStyle(storeState),
    shouldShowBanner: lessonSelectors.getShouldShowBanner(storeState),
    lessonStatus: lessonSelectors.getLessonStatus(storeState) || LESSON_STATUS.NOT_ASSIGNED,
    isDurationEditable: lessonSelectors.getIsDurationEditable(storeState),
});

export default connect(mapStateToProps)(LessonViewMeta);
